import React from "react";
import PropTypes from "prop-types";
import {GSPSSubmitButtonStyle} from "Components/Common/GSPSSubmitButton.styles";

export const GSPSSubmitButton = ({
    onClick,
    colClassName,
    form,
    buttonText = "Save",
    isLoading = false,
    isDisabled = false,
}) => {
    return <>
        <GSPSSubmitButtonStyle
            className={`${colClassName} cta-btn`}
            disabled={isDisabled}
            type="submit"
            onClick={onClick}
            form={form}
        >
            {buttonText}
            {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status" />
            }
        </GSPSSubmitButtonStyle>
    </>;
};

GSPSSubmitButton.propTypes = {
    onClick: PropTypes.func,
    colClassName: PropTypes.string,
    form: PropTypes.string,
    buttonText: PropTypes.string,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
};
